export const DECISION_TRACKS = {
  PAYROLL_DISCOUNT: "PAYROLL_DISCOUNT",
  ACCOUNTED_LOSS: "ACCOUNTED_LOSS",
  LOSS_WITHDRAWN: "LOSS_WITHDRAWN",
} as const;

export type DecisionTrack =
  (typeof DECISION_TRACKS)[keyof typeof DECISION_TRACKS];

export const DECISION_TRACK_LIST: readonly DecisionTrack[] =
  Object.values(DECISION_TRACKS);
